import { combineReducers } from "redux";
import filterReducer from "./filter/reducer";
import postsReducer from "./posts/reducer";

const rootReducer = combineReducers({
    posts: postsReducer,
    filter: filterReducer
})

export default rootReducer;